export const generateUniqueRefId = (entityType: string): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);

  return `${entityType}_${timestamp}_${random}`;
};

export const generateUniqueRefIdWithRetry = async (
  entityType: string,
  checkExists: (refId: string) => Promise<boolean>,
  maxAttempts: number = 5
): Promise<string> => {
  let attempts = 0;

  while (attempts < maxAttempts) {
    const refId = generateUniqueRefId(entityType);
    const exists = await checkExists(refId);

    if (!exists) {
      return refId;
    }

    attempts++;
    console.warn(`Generated duplicate refId: ${refId}, attempt ${attempts}`);
  }

  throw new Error(`Failed to generate unique refId after ${maxAttempts} attempts`);
};
